import React from 'react';
import { useTranslation } from 'react-i18next';
import './AudioChannelInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { AudioChannelEnum } from '../../../types/enums/AudioChannelEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const AudioChannelInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in AudioChannelEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key.split(/(?=[A-Z])/).join(' ')}`,
        value: `${AudioChannelEnum[key as keyof typeof AudioChannelEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        transcoderAudioChannel: parseInt(option.value),
      });
    } else {
      updateEncoder(project.encoder, {
        transcoderAudioChannel: parseInt(option.value),
      });
    }
  };

  return (
    <div className="audio-channel-input">
      <div className="input-title">
        {t('producer.inputs.audio-channel.title')}
        <Help
          title="Audio Channels"
          text="<b>Mono:</b> Single audio channel. Simple and uses minimal bandwidth, suitable for voice-only streams.<br/><br/><b>Stereo:</b> Two audio channels (left and right). Provides a more immersive experience for music and general audio.<br/><br/><b>Dolby Surround Sound:</b> Multi-channel surround sound. Best for high-fidelity audio or cinematic content, providing a rich, spatial listening experience."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderAudioChannel.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.audio-channel.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.audio-channel.footer')}</div>
    </div>
  );
};

export default React.memo(AudioChannelInput);
